<template>
  <EntityList
    :config="config"
    :columns="columns"
    single-edit
    :filter-vals.sync="filterVals"
    :filters="filters"
    :formatted-columns="formattedColumns"
    authority="General_Venue"
    desc-sort
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import storeModule from '../VenueStoreModule'

export default {
  components: {
    EntityList,
  },
  data() {
    return {
      filterVals: [],
      countryOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'venues',
        endpoint: 'venues',
        route: 'venues',
        title: {
          single: this.$t('Venue Add'),
          plural: this.$t('Venues'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('Title'), sortable: true },
        { key: 'country.title', label: this.$t('Country'), sortable: false },
        { key: 'city', label: this.$t('city'), sortable: false },
        { key: 'phone1', label: this.$t('telephone'), sortable: false },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [
        { key: 'startDate', type: 'date' },
        { key: 'endDate', type: 'date' },
      ]
    },

    filters() {
      return [
        {
          name: 'country',
          label: this.$t('Country'),
          options: this.countryOptions,
          colSize: 3,
        },
        {
          name: 'createdfrom',
          type: 'date',
          label: this.$t('Created From'),
          maxDateFieldIdx: '2',
          colSize: 3,
        },
        {
          name: 'createdto',
          type: 'date',
          label: this.$t('Created To'),
          minDateFieldIdx: '1',
          colSize: 3,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('enabled'),
          colSize: 3,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchCountries').then(response => {
      this.countryOptions = response.data
    })
  },
}
</script>
